'use client';

import { Box, HStack, VStack } from '@terra/ui-styled-system';
import { IconButton } from '../../../components/icon-button';
import { Text } from '../../../components/styled/text';
import { Cancel01Icon } from '@terra/ui-icons';
import { ChatSuggestionPromptRow } from './ChatSuggestionPromptRow';
import type { ChatSuggestionCategoryPanelProps } from './types';

export function ChatSuggestionCategoryPanel({
  category,
  closeLabel,
  onClose,
  onPromptClick,
  showCategoryIcon = false,
  panelId,
  borderRadius = 'lg',
}: ChatSuggestionCategoryPanelProps) {
  const HeaderIcon = category.Icon;

  return (
    <Box
      id={panelId}
      borderWidth="1px"
      borderColor="border.subtle"
      borderRadius={borderRadius}
      overflow="hidden"
      bg="bg.subtle"
      w="full"
      textAlign="left"
    >
      <HStack
        alignItems="center"
        justifyContent="space-between"
        gap={2}
        px={3}
        py={2}
        borderBottomWidth="1px"
        borderBottomColor="border.muted"
        bg="bg.muted"
      >
        <HStack gap={2} alignItems="center" minW={0}>
          {showCategoryIcon ? <HeaderIcon size={14} aria-hidden /> : null}
          <Text
            fontSize={showCategoryIcon ? '12px' : 'xs'}
            fontWeight="semibold"
            color="fg.default"
            lineClamp={showCategoryIcon ? 2 : 1}
            lineHeight="snug"
          >
            {category.title}
          </Text>
        </HStack>
        <IconButton
          type="button"
          variant="ghost"
          size="xs"
          aria-label={closeLabel}
          onClick={onClose}
        >
          <Cancel01Icon size={16} />
        </IconButton>
      </HStack>
      <VStack alignItems="stretch" gap={0}>
        {category.prompts.map((promptText, index) => (
          <ChatSuggestionPromptRow
            key={promptText}
            promptText={promptText}
            isLast={index === category.prompts.length - 1}
            onPromptClick={onPromptClick}
          />
        ))}
      </VStack>
    </Box>
  );
}
